export default {
  'SET_ACCOUNTS'(state, data) {
    state.accounts = data;
  },
  'SET_TOKEN'(state, data) {
    const {id, token} = data;
    state.accounts = state.accounts.map(item => {
      const {id: itemId} = item;
      if (parseInt(itemId, 10) === parseInt(id, 10)) {
        return {
          ...item,
          token,
        };
      }

      return item;
    });
  }
};
